<template>
  <tr>
    <td>{{item.Date | dateFormat}}</td>
    <td>{{user.Profile.Name}}</td>
    <td>{{item.Content}}</td>

    <td>
      <span v-if="isMoneyVisible">{{(item.Bonus || item.Budget) | amountFormat}}</span>
      <span v-else>-</span>
    </td>
    <!-- <td v-show="!isMobile">{{ item.EstimatedHours }}</td> -->
    <!-- 實際時數 -->
    <td v-show="!isMobile">{{ item | hoursFormatOfTaskWorkingItem }}</td>

    <td>{{item.Status}}</td>
    <td v-show="!isMobile">{{bonusIssuer.Profile.Name}}</td>
    <td v-show="!isMobile">{{item.IssuedAt | dateFormat}}</td> <!-- 簽核日期 -->
    <td v-if="!isExporting">
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="view"
      >檢視</v-btn>
      <v-chip
        v-if="isDepartmentManagerVerifiable"
        color="red"
        small
      >待審核</v-chip>
      <!-- 總經理獎金待審核 -->
      <v-chip
        v-if="isManagerReviewable && isQuickSignEnabled"
        color="red"
        small
        style="cursor:pointer;"
        @click="quickSign"
      >待審核
        <v-progress-circular
          v-show="isLoading"
          :style="isLoading?`margin-left:3px;`:''"
          :size="15"
          :width="2"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-chip>
      <v-chip
        v-else-if="isDepartmentManagerReviewable || isManagerReviewable"
        color="red"
        small
      >待審核</v-chip>
      <!-- 
      <v-chip
        v-else-if="isSubmitEnabled"
        color="red"
        small
      >待確認</v-chip> -->

      <v-icon
        v-if="isEditable"
        class="ml-1 mr-1"
        @click.stop="editItem"
      >edit</v-icon>
      <!-- <v-icon
        v-if="canEditTask"
        class="ml-1 mr-1"
        @click.stop="confirmDeleteItem"
      >delete</v-icon> -->
      <v-tooltip
        top
        v-if="canEditTask"
      >
        <template v-slot:activator="{ on }">
          <span
            v-on="on">
            <v-icon
              :disabled="!canDeleteThisTaskWorkingItem"
              class="ml-1 mr-1"
              @click.stop="confirmDeleteItem"
            >delete</v-icon>
          </span>
        </template>
        <span v-if="!canDeleteThisTaskWorkingItem">無法刪除，日誌已審核獎金</span>
        <span v-else>刪除工作日誌</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import AppDataSetting from '@/data/app-data-setting.js'
import redirectMixin from "@/ui/mixin-redirect.vue";
//quick sign
import TodoItemAutoComplete from "@/data/todo-item/TodoItemAutoComplete.js";
export default {
  mixins: [filterMixin, redirectMixin],
  components: {
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    isQuickSignEnabled: {
      type: Boolean,
      defualt: false
    },
    isExporting: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isExpanded: false,
    // quick sign
    isLoading: false,
    isEditable: false
  }),
  computed: {
    isManagerReviewable() {
      return this.myLevel > 100 && this.item.Status == "獎金簽核中";
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    user() {
      return this.users.find(o => o.ID == this.item.UserID);
    },
    bonusIssuer() {
      return (
        this.users.find(o => o.ID == this.item.BonusIssuerID) || { Profile: {} }
      );
    },
    isReportable() {
      return (
        this.myLevel == 1 &&
        this.item.UserID == this.me.ID &&
        (this.item.Status == "" || this.item.Status == "主管退回")
      ) || (
        this.myLevel == 10 && 
        this.item.UserID == this.me.ID &&
        (this.item.Status == "" || this.item.Status == "獎金退回")
      );
    },
    isDepartmentManagerReviewable() {
      return (
        this.myLevel == 10 &&
        (this.item.Status == "主管確認中" || this.item.Status == "獎金退回") &&
        AppDataSetting.findUserDepartmentIDByID(this, this.item.UserID) == this.$store.getters.myDepartment.ID
      );
    },
    isDepartmentManagerVerifiable() {
      return this.myLevel == 10 && this.item.Status == "審核預排中"; 
    },
    canDeleteThisTaskWorkingItem() {
      return this.item.Status != "獎金發放中" && this.item.Status != "已完成"
    },
    task() {
      return AppDataSetting.attachTaskWorkingItemTask(this, this.item)
    },
    isMoneyVisible () {
      return this.myLevel >= 10 || this.item.UserID == this.me.ID || this.task.MangerID == this.me.ID
    },
    // isEditable() {
    //   if (this.myLevel >= 1000 && this.item.Status != '已完成') return true; // 總經理以上都可以編輯
    //   return this.myLevel == 10 || (this.myLevel == 1 && (this.item.Status == '審核預排中' || this.item.Status == '主管確認中') && this.item.UserID == this.me.ID)  // 2023/10 突然說員工新增任務，主管確認前也要能編輯
    // },
    ...mapGetters(["me", "users", "canEditTask", "myLevel", "tasks"])
  },
  methods: {
    async getIsEditable() {
      return await this.$store.dispatch('canEditTaskWorkingItem', this.item)
    },
    view() {
      this.redirectToTaskWorkingItemInProject(this.item.ID)
    },
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Content || "") + "」?")) return;
      this.$emit("remove", this.item);
    },
    quickSign() {
      this.pass()
    },
    // copy from task-working-item-detail-dialog
    pass() {
      this.isLoading = true;

      let promise;
      let newStatus;
      let payload;

      let waitingSignBonus = this.myLevel >= 1000;
      let waitingVerifyPreArrangeWork =
        this.myLevel == 10 && this.item.Status == "審核預排中";
      let waitingSubmitWorkBonus =
        this.myLevel == 10 &&
        (this.item.Status == "主管確認中" || this.item.Status == "獎金退回");

      if (waitingSignBonus) {
        newStatus = "獎金發放中";
      } else if (waitingVerifyPreArrangeWork) {
        newStatus = "";
        payload = { ID: this.item.ID, Budget: parseInt(this.item.Budget) };
        if (payload.Budget > 1000000000) {
          return alert("獎金不可大於10億");
        }
      } else if (waitingSubmitWorkBonus) {
        newStatus = "獎金簽核中";
        payload = { ID: this.item.ID, Bonus: parseInt(this.item.Bonus), };
        if (payload.Bonus > 1000000000) {
          return alert("獎金不可大於10億");
        }
      } else {
        return alert("錯誤：狀態錯誤");
      }

      if (waitingSignBonus) {
        promise = this.$services.taskWorkingItem.sign(this, this.item.ID);
      } else if (waitingVerifyPreArrangeWork) {
        promise = this.$services.taskWorkingItem.verify(this, payload);
      } else if (waitingSubmitWorkBonus) {
        promise = this.$services.taskWorkingItem.submit(this, payload);
      } else {
        return alert("錯誤：狀態錯誤");
      }
      let actionType = waitingSignBonus ? '簽核獎金' : null

      promise
        .then(res => {
          this.$set(
            this.item,
            "Status",
            newStatus
          );
          if (newStatus == "獎金簽核中") {
            this.$set(
              this.item,
              "Bonus",
              payload.Bonus
            );
          } else if (newStatus == "") {
            this.$set(
              this.item,
              "Budget",
              payload.Budget
            );
          }
          this.$store.state.taskWorkingItem.isReloaded = true;
          TodoItemAutoComplete.notifyActionDetected(this, 'taskWorkingItem', this.item.ID, actionType)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    item: {
      handler: async function() {
        this.isEditable = await this.getIsEditable()
      },
      immediate: true
    }
  }
};
</script>
